import { PAY_BY_BANK_PAYMENT_METHOD_TYPE } from "../../../../Common/Constants";
import { SalesCondition } from "../TermsAndConditions";

export const allTermsAccepted = (termsValue: SalesCondition): boolean => {
  return (termsValue & SalesCondition.TermsAccepted) > 0 && (termsValue & SalesCondition.PrivacyPolicyAccepted) > 0;
};

export const isPayByBankSelected = (selectedPaymentMethodType: string | undefined): boolean =>
  selectedPaymentMethodType === PAY_BY_BANK_PAYMENT_METHOD_TYPE;

export const shouldShowPayByBankWarning = (
  selectedPaymentMethodType: string | undefined,
  warningLabel: string | undefined
): boolean => isPayByBankSelected(selectedPaymentMethodType) && !!warningLabel?.trim();
